import React,{useState} from 'react'
import { useEyeconxStore } from '../../store/eyeconxStore'


function StateObject() {

    const [fetchedState, setFetchedState] = useState(null);
    const {resetSurvey}  = useEyeconxStore()
    const fetchZustandState = () => {
        // Assuming your Zustand store has a `getState` method
        const state = useEyeconxStore.getState();
        setFetchedState(state);
      };

    const handleResetSurvey = ()=>{
        console.log("Handle Reset survey")
        resetSurvey()
        const state = useEyeconxStore.getState();
        setFetchedState(state);
    }
  return (
    <>
     <div>
      <h2>Cuurent State Viewer</h2>
      <button className="btn btn-primary btn-sm me-2" onClick={fetchZustandState}>Fetch Eyeconx State</button>
      <button className="btn btn-warning btn-sm" onClick={handleResetSurvey}>Reset State</button>
      {fetchedState && (
        <pre>{JSON.stringify(fetchedState, null, 2)}</pre>
      )}
    </div>
    </>
  )
}

export default StateObject